import React from "react";
import { X, Sparkles, ChevronDown } from "lucide-react";

interface SelectedSpacesDrawerProps {
  selectedSpacesChips: string[];
  showQuickActionsMenu: boolean;
  onToggleQuickActionsMenu: () => void;
  onRemoveSpaceChip: (spaceId: string) => void;
  onClearAllSpaceChips: () => void;
}

const SelectedSpacesDrawer: React.FC<SelectedSpacesDrawerProps> = ({
  selectedSpacesChips,
  showQuickActionsMenu,
  onToggleQuickActionsMenu,
  onRemoveSpaceChip,
  onClearAllSpaceChips,
}) => {
  if (selectedSpacesChips.length === 0) {
    return null;
  }

  return (
    <div className="transition-all duration-300 ease-in-out bg-orange-50/50 border-t border-slate-200 overflow-hidden max-h-32 py-2">
      <div className="px-3">
        <div className="flex items-center justify-between mb-2">
          <div className="flex items-center gap-2">
            <span className="flex items-center justify-center bg-blue-600 text-white text-[10px] font-bold w-5 h-5 rounded-full shadow-sm">
              {selectedSpacesChips.length}
            </span>
            <span className="text-xs font-semibold text-blue-900">
              Spaces Selected
            </span>
          </div>

          <div className="flex items-center gap-3 relative">
            <button
              onClick={onToggleQuickActionsMenu}
              className={`flex items-center gap-1.5 px-2 py-1 bg-white border border-slate-200 text-slate-600 rounded-md text-[10px] font-bold shadow-sm hover:bg-slate-50 hover:text-orange-600 transition ${
                showQuickActionsMenu
                  ? "ring-2 ring-orange-100 border-orange-300 text-orange-600"
                  : ""
              }`}
            >
              <Sparkles size={10} />
              <span>Quick Actions</span>
              <ChevronDown size={10} />
            </button>

            <div className="w-px h-4 bg-slate-300"></div>
            <button
              onClick={onClearAllSpaceChips}
              className="text-[10px] text-slate-400 hover:text-red-500 hover:underline"
            >
              Clear
            </button>
          </div>
        </div>

        <div className="flex gap-1.5 overflow-x-auto pb-1 no-scrollbar">
          {selectedSpacesChips.map((id, index) => (
            <div
              key={`${id}-${index}`}
              className="flex-shrink-0 flex items-center gap-1 bg-white border border-blue-100 text-blue-600 px-1.5 py-0.5 rounded text-[10px] font-mono shadow-sm"
            >
              {id}
              <button
                onClick={() => onRemoveSpaceChip(id)}
                className="hover:text-red-500"
              >
                <X size={8} />
              </button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SelectedSpacesDrawer;
